import { createAction } from '../helpers/createAction'

export const THEME_STORAGE_KEY = 'wlsy-theme'
export const THEME_CHANGE_EVENT = 'wlsy-theme-change'
export const THEME_REQUEST_EVENT = 'wlsy-theme-request'

export const requestThemeSyncAction = createAction<void>(THEME_REQUEST_EVENT)
export type RequestThemeSyncAction = ReturnType<typeof requestThemeSyncAction>
